import {
  VENDOR_PROFILE_FETCHING,
  VENDOR_PROFILE_FAILED,
  VENDOR_PROFILE_SUCCESS,
} from "../actions/types";

const initialState = {
  result: null,
  isFetching: false,
  isError: false,
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case VENDOR_PROFILE_FETCHING:
      return { ...state, result: null, isFetching: true, isError: false };
    case VENDOR_PROFILE_FAILED:
      return { ...state, result: null, isFetching: false, isError: true };
    case VENDOR_PROFILE_SUCCESS:
      return { ...state, result: payload, isFetching: false, isError: false };
    default:
      return state;
  }
}
